import { render, staticRenderFns } from "./CategoriesNavigation.vue?vue&type=template&id=a5ae91a4&scoped=true"
import script from "./CategoriesNavigation.vue?vue&type=script&lang=ts"
export * from "./CategoriesNavigation.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesNavigation.vue?vue&type=style&index=0&id=a5ae91a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ae91a4",
  null
  
)

export default component.exports